<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <el-form :label-position="labelPosition" :rules="rules" label-width="130px" :model="detailList">
          <el-form-item label="资讯标题" prop="name">
            <el-input v-model="detailList.name" placeholder="请输入资讯标题"></el-input>
          </el-form-item>
          <el-form-item label="资讯类型" prop="category" class="all_width">
            <el-select v-model="detailList.category" filterable placeholder="请选择资讯类型">
              <el-option 
                :label="item.name" 
                :value="item.id" 
                v-for="(item,index) in categoryArr" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面图" prop="image">
            <div class="organization_img"> 
              <i class="el-icon-plus avatar-uploader-icon" v-show="!showImg || detailList.image === ''"></i>
              <input type="file" name="" id="" @change="onChange($event)" >
              <img :src="detailList.image" v-show="showImg && detailList.image != ''" class="form_img">
              <img src="../../assets/image/delete.png" v-show="showImg && detailList.image != ''" class="close_img" @click="deleteImg('img')">
            </div>
            <p class="tips">尺寸为：240px*160px</p>
          </el-form-item>
          <el-form-item label="排序" >
            <el-input v-model="detailList.sort" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item label="资讯内容" prop="content">
            <div class="editor">
              <tinymce-editor v-model="detailList.content"
                :disabled="disabled"
                ref="editor">
              </tinymce-editor>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>  
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '../../utils/utils'
import TinymceEditor from '../../components/tinymce'
export default {
  name:'addOrganization',
  components:{
    TinymceEditor,
  },
  data(){
    return {
      rules:{
        name :[{required: true, message: '请输入资讯标题', trigger: 'blur'}],
        category :[{required: true, message: '请选择资讯类型', trigger: 'change'}],
        content :[{required: true, message: '请输入资讯内容', trigger: 'blur'}],
        image :[{required: true, message: '请上传封面', trigger: 'change'}],
      },
      labelPosition: 'right',
      form: {
        name: '',
        category: '',
        content:'',
        image:'',
        sort:''
      },
      ossInfor:{},
      suffix:'',
      showImg:true,
      disabled:false,
      categoryArr:[],
      detailList:{}
    }
  },
  created(){
    this.id = this.$route.params && this.$route.params.id
    this.onloadInfor()
    this.obtainCategory()
    let params = {
      id : this.id
    }
    this.getDetail(params)
  },
  mounted(){

  },
  methods:{
    obtainCategory(){
      this.$api.user.getConfig()
        .then(res=>{
          if(res.code === 0){
            this.categoryArr = res.result.information_category
          }
        }) 
    },
    getDetail(params){
      this.$api.user.detailInformation(params)
        .then(res=>{
          if(res.code === 0){
            this.detailList = res.result
          }
        })
    },
    onChange(event,type){
      var _that = this;
      let OSS = require('ali-oss')
      let client = new OSS({
        region: _that.ossInfor.region,
        accessKeyId: _that.ossInfor.accessKeyId,
        accessKeySecret: _that.ossInfor.accessKeySecret,
        stsToken:_that.ossInfor.securityToken,
        bucket: _that.ossInfor.bucket
      });
      let filename
      var files = event.target.files[0];
      let name = files.name
      const isLt5M = files.size / 1024 / 1024 <= 5;
      if (!isLt5M) {
        _that.$message.error('图片大小不能超过 5MB!');
      }else{
        if (name != '') {
          _that.suffix = Utils.get_suffix(name)
          filename = Utils.calculate_object_name(name)
        }
        client.put (_that.ossInfor.fileDir+ filename,files).then(function(result){
          _that.detailList.image = result.url
          _that.showImg = true
        }).catch(function(err){
          console.log(err)
        }) 
      }
    },
    onloadInfor(){
      let params = {
        type : 0,
      }
      this.$api.user.uploadSTS(params)
        .then(res=>{
            if(res.code === 0){
              this.ossInfor = res.result
            }
        }) 
    },
    deleteImg(){
      this.detailList.image= ''
      if(this.detailList.image){
        this.showImg = true;
      }
    },
    onSubmit(){
      let params = {
        id:this.id,
        name: this.detailList.name,
        category:this.detailList.category,
        content:this.detailList.content,
        image:this.detailList.image,
        sort:this.detailList.sort
      }
      if(!this.detailList.name){
        this.$message.error('请输入资讯标题')
      }else if(!this.detailList.image){
        this.$message.error('请上传封面')
      }else if(!this.detailList.category){
        this.$message.error('请选择资讯类型')
      }else if(!this.detailList.content){
        this.$message.error('请输入内容')
      }else{
        this.$api.user.editInformation(params)
          .then(res=>{
              if(res.code === 0){
                this.$message.success('编辑成功！')
                this.$router.replace({
                  path:'/information/information'
                })
              }
          }) 
      }
    },
    //清空内容
    clear() {
      this.$refs.editor.clear()
    }
  },
   computed: {
      
  }
}
</script>>
<style lang="scss" scoped>
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/editRotation.scss';
  @import '../../assets/scss/addOrganization.scss';
  .organization_img{
    width:240px;
  }
  .tips{
    color:#999;
  }
  .all_width .el-select{
    width:100%;
  }
</style>
